import {calculateTimePass} from '@/_application/core/utils/date-time';
import {useEffect, useState} from 'react';

interface IProps {
    dateFrom: string;
    dateTo: string;
    timeInterval?: number;
    className?: string;
    onTimeUp?: () => void;
}
function TimerProgress({dateFrom, dateTo, timeInterval = 1000, className, onTimeUp}: IProps) {
    const [percentage, setPercentage] = useState<number>(calculateTimePass(dateFrom, dateTo));

    useEffect(() => {
        if (percentage >= 100 && onTimeUp) {
            onTimeUp();
            return;
        }
        const timer = setTimeout(() => {
            setPercentage(calculateTimePass(dateFrom, dateTo));
        }, timeInterval);
        return () => clearTimeout(timer);
    }, [percentage]);

    return (
        <div className="h-2 overflow-hidden rounded-xl border border-white bg-transparent">
            <div className="h-full bg-white" style={{width: `${percentage}%`}}></div>
        </div>
    );
}

export default TimerProgress;
